import keys from "../translations/keys";
import {NavLink, useHistory} from "react-router-dom";
import React from "react";
import {useTranslation} from "react-i18next";
import useAuth from "../Hooks/useAuth";
import Image from "react-image-webp";
import LangSelector from "./LangSelector";

const Navbar = () => {
    const {t} = useTranslation();
    const {state} = useAuth();
    const history = useHistory();

    const exitBtn =
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19 23H10C8.89543 23 8 22.1046 8 21V17H10V21H19V7H10V11H8V7C8 5.89543 8.89543 5 10 5H19C20.1046 5 21 5.89543 21 7V21C21 22.1046 20.1046 23 19 23ZM12 18V15H3V13H12V10L17 14L12 18Z"
                fill="#F2F2F2"/>
            <rect x="1" y="1" width="26" height="26" rx="13" stroke="white" strokeWidth="2"/>
        </svg>

    const logout = async () => {
        await state.LogoutAction();
    }

    return <div className="navbar">
        <div className="logo" onClick={() => history.push('/main')}>
            <Image className="logo--icon" src='/divine-main.png' webp='/divine-main.webp' alt={'DIVINE'}/>
            <div className="logo--text">divine</div>
        </div>
        <div className="link-group">
            <NavLink className="link" exact to='/buy'>{t(keys.lefPanel.dashboard.buy)}</NavLink>
            <NavLink className="link" exact to='/main'>{t(keys.lefPanel.dashboard.main)}</NavLink>
            <NavLink className="link" exact to='/plugins'>{t(keys.lefPanel.dashboard.plugins)}</NavLink>
            <LangSelector/>
            <div className='exit-btn' onClick={logout}>{exitBtn}</div>
        </div>
    </div>
}

export default Navbar;
